<script>
import ScholarshipSideDialog from "../ScholarshipSideDialog.vue";
import AmsuScholarshipCard from "../../Cards/AmsuScholarshipCard.vue";
import pdf from "vue-pdf";
import _ from "lodash";
import {mapActions, mapState} from "vuex";
import MeetingVoteCommentCard from "../../Cards/Meeting/MeetingVoteCommentCard.vue";
import moment from "moment";
import DocumentViewerSection from "../AchievementStatementDialog/DocumentViewerSection.vue";
import ParamAchievementSection from "../AchievementStatementDialog/ParamAchievementSection.vue";
export default {
  name: "TheMeetingAchievementsStatementDialog",

  components: {
    MeetingVoteCommentCard,
    pdf,
    ScholarshipSideDialog,
    AmsuScholarshipCard,
    DocumentViewerSection,
    ParamAchievementSection
  },

  data() {
    return {
      page: 1,
      itemsPerPage: 1,
      loadingAchievement: false,
      loadingVote: false,
    };
  },

  watch: {
    visible: function () {
      if (!this.visible) {
        this.page = 1;
        this.numPages = undefined;
      }
    },

    achievements(newVal, oldVal) {
      if (this.page > newVal.length && this.visible) this.page-=1;
    },

  },

  props: {
    visible: Boolean,
    achievements: Array,
  },

  computed: {

    ...mapState({
      statement: state => state.scholarship_competition.statement,
    }),

    numberOfPages () {
      return Math.ceil(this.achievements.length / this.itemsPerPage)
    },

    currentAchievement() {
      return this.achievements[this.page - 1] || {}
    },

    achievementId() {
      return this.currentAchievement?.id;
    },

    sizeCommentsAchievement() {
      return this.currentAchievement?.comments?.length || 0;
    },

  },

  methods: {
    ...mapActions({
      openDialog: "scholarship_comment/openDialog",
    }),

  }
}
</script>

<template>
  <scholarship-side-dialog
    :visible="visible"
    @close="$emit('close')"
    width="1200px"
    position-dialog="right"
  >

      <v-card-title>
        <v-row
          align="center"
          justify="center">
          <v-col cols="12" class="text-center">
            <v-pagination
              circle
              color="teal darken-3"
              v-model="page"
              :length="numberOfPages"
              :total-visible="7">
            </v-pagination>
          </v-col>
        </v-row>

        <v-spacer/>

        <v-btn
          @click="$emit('openEditAchievement', currentAchievement)"
          small
          outlined
          class="rounded-xl"
          color="warning"
          :disabled="sizeCommentsAchievement > 0"
        >
          Ред-ть
          <v-icon small right> fa-edit </v-icon>
        </v-btn>
        <div class="mx-1"></div>
        <v-btn
          @click="openDialog({achievementId: achievementId, competitionId:statement.id})"
          small
          outlined
          class="rounded-xl"
          :loading="loadingAchievement"
          color="error"
          :disabled="sizeCommentsAchievement > 0"
        >
          Удалить
          <v-icon small right> fa-trash </v-icon>
        </v-btn>
        <v-btn
          @click="$emit('close')"
          fab
          small
          icon
          top
          left
        >
          <v-icon small> fa-times </v-icon>
        </v-btn>
      </v-card-title>

      <v-divider/>

      <v-card-text class="mt-2">
        <v-row>

          <v-col cols="12" md="7">
            <amsu-scholarship-card
              style="height: 83vh"
            >
              <document-viewer-section
                :achievement="currentAchievement"
              />
            </amsu-scholarship-card>
          </v-col>

          <v-col cols="12" md="5" class="pb-0">

            <param-achievement-section
              :achievement="currentAchievement"
            />

            <meeting-vote-comment-card
              class="mt-3"
              :achievement="currentAchievement"
              :statement="statement"
            />

          </v-col>

        </v-row>
      </v-card-text>

  </scholarship-side-dialog>
</template>

<style scoped>
</style>